import Quill from 'quill';

/**
 * Quill 2.0.3 exports video and formula embeds through getSemanticHTML() without escaping their
 * values (CVE-2025-15056), and ngx-quill stores that export as the editor's HTML value. These
 * subclasses escape the values; they are registered once, before any editor is created.
 */
export function escapeQuillValue(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

const Video: any = Quill.import('formats/video');
const Formula: any = Quill.import('formats/formula');

export class SafeVideo extends Video {
  html(): string {
    const video = escapeQuillValue(this.value().video);
    return `<a href="${video}">${video}</a>`;
  }
}

export class SafeFormula extends Formula {
  html(): string {
    return `<span>${escapeQuillValue(this.value().formula)}</span>`;
  }
}

Quill.register({ 'formats/video': SafeVideo, 'formats/formula': SafeFormula }, true);
